import { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { useInstanceSelector } from '@s20/hooks/redux.hooks';
import { checkUserHasPermission } from '@s20/selectors/features/permissions.selectors';
import { IconButton } from '../../../../../common/forms/FormElements';
import { ApplicationPermissions } from '../../../../../Common';
import { JobContext } from '../JobContext';
import { ConfirmationStatus } from '../../../../../dispatch/Dispatch';
import { useReplaceJobAssignment } from './useReplaceJobAssignment.hook';

export const ReplaceJobAssignment = ({ jobAssignmentId, resourceType }) => {
    const { job, day } = useContext(JobContext);

    const hasDispatchEditPermission = useInstanceSelector(checkUserHasPermission, ApplicationPermissions.dispatch_edit);

    const dayAssignments = job?.assignments?.[day];
    const jobAssignment = dayAssignments && [...dayAssignments.staff, ...(dayAssignments.equipment || [])]
        .find((asn) => asn.jobAssignmentId === jobAssignmentId);

    const isReplaceable = jobAssignment
        && jobAssignment.assignment?.isAutoAssignment
        && [
            ConfirmationStatus.Unfilled,
            ConfirmationStatus.Scheduled,
        ].includes(jobAssignment.assignment?.confirmationStatusId);

    const resourceName = jobAssignment?.assignment?.name || jobAssignment?.name || 'this resource';

    const handleReplaceDayJob = useReplaceJobAssignment({
        day,
        job,
        jobAssignmentId,
        resourceType,
        resourceName,
        staff: dayAssignments?.staff,
        equipment: dayAssignments?.equipment,
    });

    if (!isReplaceable) {
        return null;
    }

    return (
        <IconButton
            color="link"
            title={`Replace this ${resourceType}`}
            className="p-0 mr-2"
            disabled={!hasDispatchEditPermission}
            onClick={handleReplaceDayJob}
        >
            <FontAwesomeIcon
                icon={faPencil}
                className="text-primary"
            />
        </IconButton>
    );
};
